import { DeepReadonly, ICore } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const defaultCore: DeepReadonly<ICore> = deepFreeze({
  student_id: '',
  student_number: '',
  university: '',
  createdAt: 0,
  updatedAt: 0,
  legalAdviseDisclaimer: false,
  infoProcessingConsent: false,
  casIssued: false,
  email: '',
  assignedAgents: [],
  isPendingCognitoUser: false
});
